import { Box, Heading, Input } from '@chakra-ui/react'

import estados from 'utils/estados-cidades'
import estate from '../estates.json'
import Layout from 'components/Layout/Default'
import Container from 'components/Container'

import * as S from './styles'
import { useRouter } from 'next/router'
import { transformarParaUrlAmigavel } from '../index.page'
import { useEffect, useState } from 'react'

const Contato = ({
  provinceName,
  provinceSigla,
  cities,
  title,
  description,
  keywords,
  tip,
}) => {
  const router = useRouter()

  const [search, setSearch] = useState()

  function handleItemClick(url) {
    router.push(url)
  }

  return (
    <Layout
      category={`Selecione sua cidade`}
      categorySize="25px"
      title={title}
      description={description}
      keywords={keywords}
    >
      <section>
        <Container>
          <S.Flex>
            <S.Left>
              {/* <h2>Preencha o formulário abaixo</h2> */}
              <S.WrapperItemList>
                <Input
                  placeholder="Filtre aqui pelo nome da sua cidade"
                  onChange={(e) => setSearch(e.target.value)}
                />
                <br />
                <br />
                {search &&
                  cities?.map(
                    (item) =>
                      item.toLowerCase().includes(search.toLowerCase()) && (
                        <S.ItemList
                          key={`item-searched-${item}`}
                          onClick={() =>
                            handleItemClick(
                              `/comprar-grama/${provinceSigla.toLowerCase()}/${transformarParaUrlAmigavel(
                                item
                              )}`
                            )
                          }
                        >
                          {item}
                        </S.ItemList>
                      )
                  )}

                {!search &&
                  cities?.map((item) => (
                    <S.ItemList
                      key={`item-no-search-${item}`}
                      onClick={() =>
                        handleItemClick(
                          `/comprar-grama/${provinceSigla.toLowerCase()}/${transformarParaUrlAmigavel(
                            item
                          )}`
                        )
                      }
                    >
                      {item}
                    </S.ItemList>
                  ))}
              </S.WrapperItemList>
            </S.Left>

            <S.Right>
              <S.About>
                <h3>Dica rápida</h3>
                <S.Item>
                  <S.Text>{tip}</S.Text>
                </S.Item>
              </S.About>
            </S.Right>
          </S.Flex>
        </Container>
      </section>
    </Layout>
  )
}

export async function getStaticPaths() {
  const paths = estados.map((estado) => ({
    params: { province: estado.sigla.toLowerCase() },
  }))

  return { paths, fallback: false }
}

export async function getStaticProps({ params }) {
  const estado = estados.find((e) => e.sigla.toLowerCase() === params.province)
  const estadoPagina = estate.find((e) => e.id === params.province)

  return {
    props: {
      provinceName: estado.nome,
      provinceSigla: estado.sigla,
      cities: estado.cidades,
      ...estadoPagina,
    },
  }
}

export default Contato
